import React, { FC, useEffect, useId, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { ErrorMessage } from '@eika/attention-message';
import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { MediumCenteredContainer } from '@eika/engine-view';
import { Loader } from '@eika/loader';

import { ValgtWeb } from '../../generated-types';
import { useForespoerVerdivurdering } from '../../hooks/useEiendom';
import { useKvitteringInfo } from '../../hooks/useTilbakemelding';
import { useTranslation } from '../../translations';
import Tilbakemelding from './tilbakemelding';

export type TilbakemeldingFormData = {
    tilbakemeldingValg: ValgtWeb;
    kommentar: string;
};

const Kvittering: FC = () => {
    const { kvittering } = useTranslation();
    const { soeknadId } = useParams();
    const { data: kvitteringInfo, isLoading } = useKvitteringInfo(soeknadId || '');
    const { state } = useLocation();
    const harSendtVerdivurdering = useRef(false);
    const { mutate: sendVerdivurdering } = useForespoerVerdivurdering();
    const id = useId();

    useEffect(() => {
        if (
            !harSendtVerdivurdering.current &&
            state &&
            state.verdivurderingInfo !== null &&
            state.verdivurderingInfo !== undefined
        ) {
            sendVerdivurdering(state.verdivurderingInfo);
            harSendtVerdivurdering.current = true;
        }
    }, [harSendtVerdivurdering, sendVerdivurdering, state]);

    if (isLoading)
        return (
            <div className="margin-top-extra-large">
                <Loader />
            </div>
        );

    return (
        <div>
            <MediumCenteredContainer>
                <div>
                    <div className="appcard-center-text">
                        <CheckmarkAnimation key={id} />
                        <h1 className="light">{kvittering.title}</h1>
                        {!kvitteringInfo?.harMedlaantaker && (
                            <span className="typography-paragraph">{kvittering.paragrafLaantaker}</span>
                        )}
                        {kvitteringInfo?.harMedlaantaker && kvitteringInfo.erHovedlaantaker && (
                            <>
                                <span className="typography-paragraph">
                                    {kvittering.paragrafMedlaantaker1.replace(
                                        '{navn}',
                                        kvitteringInfo?.navnMedlaantaker ? kvitteringInfo?.navnMedlaantaker : '',
                                    )}
                                </span>
                                <span className="typography-paragraph">{kvittering.paragrafMedlaantaker2}</span>
                            </>
                        )}
                    </div>
                    {kvitteringInfo?.verdivurderingFeilet && (
                        <div className="margin-bottom-medium">
                            <ErrorMessage text={kvittering.verdivurderingFeil} />
                        </div>
                    )}
                    <Tilbakemelding kvitteringInfo={kvitteringInfo} />
                </div>
            </MediumCenteredContainer>
        </div>
    );
};

export default Kvittering;
